// Customer type vocabulary mirrors FloorCore's Customer "Customer Type"
// field (see _build_plan/refinements.md) so ERP sync stays an ID mapping.
export const CUSTOMER_TYPES = [
  "production_builder",
  "custom_builder",
  "retail",
  "commercial",
  "multifamily",
] as const

export type CustomerType = (typeof CUSTOMER_TYPES)[number]

export const CUSTOMER_TYPE_LABELS: Record<CustomerType, string> = {
  production_builder: "Production builder",
  custom_builder: "Custom builder",
  retail: "Retail",
  commercial: "Commercial",
  multifamily: "Multifamily",
}

// Plural section headings for the projects sidebar. Production builders keep
// the plain "Builders" label — that's the team's everyday vocabulary.
export const CUSTOMER_TYPE_SECTIONS: Record<CustomerType, string> = {
  production_builder: "Builders",
  custom_builder: "Custom builders",
  retail: "Retail",
  commercial: "Commercial",
  multifamily: "Multifamily",
}
